import { useTranslation } from '../../hooks/support/useTranslation';
import { useRouter } from 'next/router';
import { Box, Button, Container, Divider, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import * as React from 'react';
import { Route } from 'utility/routes';

export const SidebarAgentSection = ({ session }) => {
  const { t } = useTranslation('common');
  const router = useRouter();

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: '0',
        width: '100%',
        borderRadius: '12px 12px 0px 0px',
        backgroundColor: 'primary.main',
      }}
    >
      <Container
        sx={{ display: 'flex', flexDirection: 'column', padding: '16px' }}
      >
        <Typography
          variant={'body1'}
          fontWeight={700}
          color={'primary.contrastText'}
        >
          Agent:
        </Typography>
        <Typography color={'primary.contrastText'}>{session?.name}</Typography>
      </Container>
      <Divider sx={{ backgroundColor: 'primary.dark', opacity: 0.2 }} />
      <Container sx={{ padding: '16px' }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => {
            void router.replace(Route.AGENT_SEARCH_PARTY);
          }}
          sx={{
            flex: '1 1 40%',
            backgroundColor: 'success.main',
            color: 'primary.main',
            fontWeight: 600,
            fontSize: '15px',
            textTransform: 'none',
            '&.Mui-disabled': {
              backgroundColor: 'success.light',
              opacity: '0.9',
            },
            '&:hover': {
              color: 'primary.contrastText',
            },
          }}
        >
          {t('agent.newSearch')}
        </Button>
      </Container>
    </Box>
  );
};
